import React from 'react';
import PropTypes from 'prop-types';
import IconCollection from "../../IconCollection/IconCollection";
import { useDispatch } from 'react-redux';

const EventModal = ({ eventModal, setEventModal }) => {
  const dispatch = useDispatch();
  return (
    <div className={`fixed top-[-130px] left-0 right-0 bottom-0 z-10 w-full bg-black bg-opacity-25 flex justify-center items-center transition-all ${eventModal ? "block" : "hidden"}`}>
      <div className="bg-light rounded-md w-full px-10 py-6 max-w-[600px]">
        <div className="w-full flex justify-between items-center">
          <p className="text-[#1A1A1A] font-bebas text-[32px]">Create New Event</p>
          <button onClick={() => dispatch(setEventModal(false))}>
            <IconCollection customClass='md:w-6 md:h-6 w-[10px] h-[10px]' name="close" />
          </button>
        </div>
        <form>
          <input type="text" className="max-w-[520px] w-full h-12 border-[1px] border-[#7D7D7D] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]" placeholder="Add Event Name" />
          <div className="pt-6 flex gap-4 items-center">
            <IconCollection name="clock-gray" />
            <input className="max-w-[220px] w-full h-10 border-[1px] border-[#7D7D7D] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]" type="date" />
            <input className="max-w-[155px] w-full h-10 border-[1px] border-[#7D7D7D] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]" type="time" />
          </div>
          <div className="pt-6 flex gap-4 items-center">
            <IconCollection name="location-gray" />
            <input className="max-w-[220px] w-full h-10 border-[1px] border-[#7D7D7D] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]" type="text" />
          </div>
          <div className="pt-6 flex gap-6 items-center">
            <select className="max-w-[174px] w-full h-10 border-none bg-[#F2F2F2] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]">
              <option value="Team A">Team A</option>
              <option value="Team B">Team B</option>
              <option value="Team C">Team C</option>
              <option value="Team D">Team D</option>
            </select>
            <div className="text-2xl text-[#1A1A1A] font-bebas">VS</div>
            <select className="max-w-[174px] w-full h-10 border-none bg-[#F2F2F2] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]">
              <option value="Team A">Team A</option>
              <option value="Team B">Team B</option>
              <option value="Team C">Team C</option>
              <option value="Team D">Team D</option>
            </select>
          </div>
          <div className="w-full pt-4">
            <select className="max-w-[415px] w-full h-10 border-[1px] bg-white border-[#7D7D7D] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]">
              <option value="KU 12 PA">KU 12 PA</option>
              <option value="KU 12 PA">KU 12 PA</option>
              <option value="KU 12 PA">KU 12 PA</option>
              <option value="KU 12 PA">KU 12 PA</option>
            </select>
          </div>
          <div className="w-full pt-4">
            <select className="max-w-[174px] w-full h-10 border-none bg-[#F2F2F2] rounded outline-none px-4 py-2 font-montserrat text-sm text-[#636363]">
              <option value="Semifinal">Semifinal</option>
              <option value="Semifinal">Semifinal</option>
              <option value="Semifinal">Semifinal</option>
              <option value="Semifinal">Semifinal</option>
            </select>
          </div>
          <input type="submit" value="Save" className="font-bebas bg-primary text-light rounded max-w-[80px] h-12 flex justify-center items-center w-full mt-6" />
        </form>
      </div>
    </div>
  );
};

EventModal.propTypes = {
  eventModal: PropTypes.bool.isRequired,
  setEventModal: PropTypes.func.isRequired,
};

export default EventModal;